export const version = {
  timeStamp: '2026-10-20 05:46:56 PM -03',
  version: '0.0.13-20261020174656',
}
